export const profile = {
  name: "Parmeshwar",
  title: "Senior Full Stack Developer",
  tagline: "Building high-performance web apps from IIT Indore to Singapore — React, Go, AI & Web3.",
  email: "parmeshwarpanwar777@gmail.com",
  phone: "9116375367",
  location: "Delhi, India",
  github: "https://github.com/PARMESHWARPANWAR",
  linkedin: "https://linkedin.com/in/parmeshwar777",
  bio: `IIT Indore graduate turned Senior Full Stack Developer with 5+ years of experience building production-grade web applications. From crypto exchange platforms in Singapore to AI-powered chatbots, I craft performant, scalable solutions across the entire stack.`,
};

export const experience = [
  {
    role: "Freelance Full Stack Developer & Project Lead",
    company: "Self-employed",
    period: "Oct 2024 – Present",
    location: "Remote",
    highlights: [
      "Building Pump Market Cap — a crypto tracking platform (CoinMarketCap-like) with Next.js, TanStack Query",
      "Optimized client-side caching with IndexedDB + Zustand, minimizing API calls",
      "Integrated TradingView charts with real-time data streaming",
      "Architected for high-frequency data streams with seamless UX",
    ],
  },
  {
    role: "Senior Full Stack Developer",
    company: "Syndr",
    period: "Jul 2023 – Oct 2024",
    location: "Singapore",
    highlights: [
      "Built Syndr's main website single-handedly — Next.js, TypeScript, i18next, Tailwind CSS",
      "Implemented exchange web app with Privy/Wagmi onboarding and TradingView charts",
      "Wrote Solidity smart contracts for registry functions with comprehensive tests",
      "Managed Golang backend: WebSocket & REST APIs for positions, orders, portfolios",
    ],
  },
  {
    role: "Full Stack Developer",
    company: "Climajo",
    period: "Aug 2022 – May 2023",
    location: "Gurugram, India",
    highlights: [
      "Built real-time customer engagement chatbot with Flask, Node.js, ChatGPT API",
      "Developed B2B portal with React.js, TypeScript, Hasura, and real-time messaging",
      "Designed Climajo-Portal with thought-flow registration and payment integration",
    ],
  },
  {
    role: "Software Developer",
    company: "GetMega",
    period: "Sep 2021 – Aug 2022",
    location: "Bengaluru, India",
    highlights: [
      "Built responsive web apps with React.js, TypeScript, Tailwind CSS",
      "Developed Ludo game using libGDX with MVC pattern and AI bot (MinMax + Alpha-beta pruning)",
      "Integrated cgo library to use multiple languages within Go",
    ],
  },
];

export const skills = {
  Frontend: ["React.js", "Next.js", "TypeScript", "Tailwind CSS", "Zustand", "Redux", "React Native", "Framer Motion"],
  Backend: ["Golang", "Node.js", "Express", "WebSockets", "REST APIs"],
  "AI & Web3": ["OpenAI API", "Solidity", "Hardhat", "Wagmi", "Privy", "Smart Contracts"],
  Databases: ["PostgreSQL", "MongoDB", "IndexedDB"],
  Tools: ["AWS", "Docker", "Jest", "React Testing Library", "TradingView Charts"],
};

export const projects = [
  {
    title: "Syndr Exchange",
    description: "Full-featured crypto exchange web app with Privy/Wagmi onboarding, financial charts, smart contracts, and Golang backend APIs.",
    tech: ["React", "Wagmi", "Privy", "Viem", "Zustand", "TypeScript", "TradingView", "Recharts", "i18next"],
    link: "https://www.hotstuff.trade/",
    status: "Live",
  },
  {
    title: "Pump Market Cap",
    description: "A comprehensive cryptocurrency tracking platform similar to CoinMarketCap with real-time data streams, TradingView charts, and optimized caching.",
    tech: ["Next.js", "TypeScript", "TanStack Query", "Zustand", "IndexedDB", "TradingView"],
    link: "https://pumpmarketcap.com/",
    status: "Live",
  },
  {
    title: "Use Streak - Build Better Habits",
    description: "Build lasting habits through consistency. Track streaks, earn freeze protection, and visualize progress with beautiful calendars. Features intelligent notifications, celebration animations, and offline-first architecture.",
    tech: ["React Native","Expo","TypeScript","Supabase","PostgreSQL"],
    link: "https://usestreak.vercel.app/",
    status: "Live",
  },
  // AI Chatbot Platform — hidden, no live link to show (replaced by Climajo below); re-enable if a demo/repo link becomes available
  // {
  //   title: "AI Chatbot Platform",
  //   description: "Real-time customer engagement chatbot integrated with ChatGPT API, featuring B2B portal with one-to-one messaging.",
  //   tech: ["Flask", "Node.js", "React.js", "OpenAI API", "Hasura"],
  //   link: "#",
  //   status: "Shipped",
  // },
  {
    title: "Climajo",
    description: "Cloud-based B2B software suite for climate-conscious brands, including a real-time customer engagement chatbot with ChatGPT integration and a B2B portal with one-to-one messaging.",
    tech: ["React.js", "TypeScript", "Flask", "Node.js", "OpenAI API", "Hasura"],
    link: "https://www.climajo.com/",
    status: "Live",
  },
];

export const reactRoadmap = {
  title: "React Internals & Performance",
  description: "From Fiber architecture to production-grade performance. Master reconciliation, memoization, and build real demos.",
  totalDays: 49,
  phases: [
    {
      id: 1,
      title: "React Internals & Performance",
      days: "1–14",
      color: "#00f5d4",
      description: "Master Fiber architecture, reconciliation, re-renders, memoization, and virtualisation. Build the React Rendering Demo.",
      topics: [
        { day: 1, title: "React Fiber Architecture", slug: "fiber-architecture", status: "published" },
        { day: 2, title: "Reconciliation Deep Dive", slug: "reconciliation", status: "published" },
        { day: 3, title: "Virtual DOM vs Real DOM", slug: "virtual-dom", status: "published" },
        { day: 4, title: "Re-render Triggers", slug: "rerender-triggers", status: "published" },
        { day: 5, title: "useMemo & useCallback", slug: "usememo-usecallback", status: "published" },
        { day: 6, title: "React.memo & PureComponent", slug: "react-memo", status: "published" },
        { day: 7, title: "Code Splitting & Lazy Loading", slug: "code-splitting", status: "coming-soon" },
        { day: 8, title: "Profiler API", slug: "profiler-api", status: "coming-soon" },
        { day: 9, title: "Concurrent Mode Basics", slug: "concurrent-mode", status: "coming-soon" },
        { day: 10, title: "useTransition & useDeferredValue", slug: "usetransition", status: "coming-soon" },
        { day: 11, title: "Suspense Deep Dive", slug: "suspense", status: "coming-soon" },
        { day: 12, title: "Error Boundaries", slug: "error-boundaries", status: "coming-soon" },
        { day: 13, title: "Context Optimization", slug: "context-optimization", status: "coming-soon" },
        { day: 14, title: "React Rendering Demo Build", slug: "rendering-demo", status: "coming-soon" },
      ],
    },
    {
      id: 2,
      title: "TypeScript — Systems Thinking",
      days: "15–21",
      color: "#a855f7",
      description: "Discriminated unions, mapped/conditional types, generics, Zod validation. Type the real SigNoz API.",
      topics: [
        { day: 15, title: "TypeScript Generics Mastery", slug: "generics", status: "coming-soon" },
        { day: 16, title: "Discriminated Unions", slug: "discriminated-unions", status: "coming-soon" },
        { day: 17, title: "Mapped & Conditional Types", slug: "mapped-types", status: "coming-soon" },
        { day: 18, title: "Template Literal Types", slug: "template-literals", status: "coming-soon" },
        { day: 19, title: "Zod Schema Validation", slug: "zod-validation", status: "coming-soon" },
        { day: 20, title: "Type-Safe API Clients", slug: "type-safe-api", status: "coming-soon" },
        { day: 21, title: "Typing Real SigNoz API", slug: "signoz-api", status: "coming-soon" },
      ],
    },
    {
      id: 3,
      title: "Observability Domain",
      days: "22–28",
      color: "#f59e0b",
      description: "Run SigNoz locally, study metrics/traces/logs, explore OpenTelemetry, form real product opinions.",
      topics: [
        { day: 22, title: "Observability Fundamentals", slug: "observability-101", status: "coming-soon" },
        { day: 23, title: "OpenTelemetry Setup", slug: "opentelemetry", status: "coming-soon" },
        { day: 24, title: "Metrics Deep Dive", slug: "metrics", status: "coming-soon" },
        { day: 25, title: "Distributed Tracing", slug: "tracing", status: "coming-soon" },
        { day: 26, title: "Log Management", slug: "log-management", status: "coming-soon" },
        { day: 27, title: "SigNoz Local Setup", slug: "signoz-setup", status: "coming-soon" },
        { day: 28, title: "Production Monitoring", slug: "production-monitoring", status: "coming-soon" },
      ],
    },
    {
      id: 4,
      title: "Dashboard Engineering",
      days: "29–35",
      color: "#10b981",
      description: "Canvas vs SVG, ECharts, LTTB downsampling, real-time SSE, Zustand, URL-driven state.",
      topics: [
        { day: 29, title: "Canvas vs SVG Performance", slug: "canvas-svg", status: "coming-soon" },
        { day: 30, title: "ECharts Deep Dive", slug: "echarts", status: "coming-soon" },
        { day: 31, title: "LTTB Downsampling", slug: "lttb", status: "coming-soon" },
        { day: 32, title: "Real-time SSE Streams", slug: "sse-streams", status: "coming-soon" },
        { day: 33, title: "Zustand Advanced Patterns", slug: "zustand-advanced", status: "coming-soon" },
        { day: 34, title: "URL-Driven State", slug: "url-state", status: "coming-soon" },
        { day: 35, title: "Dashboard Build Project", slug: "dashboard-build", status: "coming-soon" },
      ],
    },
    {
      id: 5,
      title: "Portfolio Projects",
      days: "36–42",
      color: "#ef4444",
      description: "Build 2 showpieces: Mini Observability Dashboard + Trace Waterfall Viewer. Deploy to Vercel.",
      topics: [
        { day: 36, title: "Project Architecture Planning", slug: "project-planning", status: "coming-soon" },
        { day: 37, title: "Mini Observability Dashboard", slug: "mini-dashboard", status: "coming-soon" },
        { day: 38, title: "Trace Waterfall Viewer", slug: "trace-waterfall", status: "coming-soon" },
        { day: 39, title: "Performance Optimization", slug: "perf-optimization", status: "coming-soon" },
        { day: 40, title: "Testing Strategy", slug: "testing-strategy", status: "coming-soon" },
        { day: 41, title: "Vercel Deployment", slug: "vercel-deploy", status: "coming-soon" },
        { day: 42, title: "Final Project Review", slug: "final-review", status: "coming-soon" },
      ],
    },
    {
      id: 6,
      title: "Interview Preparation",
      days: "43–49",
      color: "#f59e0b",
      description: "Clone SigNoz codebase, submit a PR, practise system design, war stories, mock interview.",
      topics: [
        { day: 43, title: "SigNoz Codebase Deep Dive", slug: "signoz-codebase", status: "coming-soon" },
        { day: 44, title: "Contributing to Open Source", slug: "open-source-pr", status: "coming-soon" },
        { day: 45, title: "System Design Patterns", slug: "system-design", status: "coming-soon" },
        { day: 46, title: "React Interview War Stories", slug: "war-stories", status: "coming-soon" },
        { day: 47, title: "Behavioral Prep", slug: "behavioral-prep", status: "coming-soon" },
        { day: 48, title: "Mock Interview Practice", slug: "mock-interview", status: "coming-soon" },
        { day: 49, title: "Final Mock & Review", slug: "final-mock", status: "coming-soon" },
      ],
    },
  ],
};

export const pythonRoadmap = {
  title: "Python Backend & AI Engineering",
  description: "From Python internals to production AI agents. A 10-week journey to founding engineer level.",
  totalDays: 47,
  weeks: [
    {
      id: 1,
      title: "Python Foundations",
      days: "1–7",
      color: "#f59e0b",
      description: "Advanced Python Internals, Type Hints & Protocols, Design Patterns",
      topics: [
        { day: 1, title: "Python Internals & Memory Model", slug: "python-internals", status: "coming-soon" },
        { day: 2, title: "Type Hints & Protocols", slug: "type-hints", status: "coming-soon" },
        { day: 3, title: "Async/Await Deep Dive", slug: "async-await", status: "coming-soon" },
        { day: 4, title: "Design Patterns in Python", slug: "design-patterns", status: "coming-soon" },
        { day: 5, title: "Decorators & Metaclasses", slug: "decorators", status: "coming-soon" },
        { day: 6, title: "Performance Optimization", slug: "python-perf", status: "coming-soon" },
        { day: 7, title: "Testing with pytest", slug: "pytest", status: "coming-soon" },
      ],
    },
    {
      id: 2,
      title: "FastAPI & Pydantic",
      days: "8–14",
      color: "#00f5d4",
      description: "FastAPI Deep Dive, Pydantic v2 & Validation, Auth & Security",
      topics: [
        { day: 8, title: "FastAPI Fundamentals", slug: "fastapi-intro", status: "coming-soon" },
        { day: 9, title: "Pydantic v2 Deep Dive", slug: "pydantic-v2", status: "coming-soon" },
        { day: 10, title: "Dependency Injection", slug: "dependency-injection", status: "coming-soon" },
        { day: 11, title: "JWT Auth & Security", slug: "jwt-auth", status: "coming-soon" },
        { day: 12, title: "Background Tasks", slug: "background-tasks", status: "coming-soon" },
        { day: 13, title: "WebSockets in FastAPI", slug: "websockets-fastapi", status: "coming-soon" },
        { day: 14, title: "API Testing Strategies", slug: "api-testing", status: "coming-soon" },
      ],
    },
    {
      id: 3,
      title: "LLM Fundamentals & Prompt Engineering",
      days: "15–17",
      color: "#a855f7",
      description: "LLM Fundamentals, Prompt Engineering, Function Calling",
      topics: [
        { day: 15, title: "LLM Architecture Fundamentals", slug: "llm-fundamentals", status: "coming-soon" },
        { day: 16, title: "Advanced Prompt Engineering", slug: "prompt-engineering", status: "coming-soon" },
        { day: 17, title: "Function Calling & Tool Use", slug: "function-calling", status: "coming-soon" },
      ],
    },
    {
      id: 4,
      title: "RAG & Document Processing",
      days: "18–22",
      color: "#10b981",
      description: "RAG System, Document Processing Pipeline",
      topics: [
        { day: 18, title: "Vector Databases & Embeddings", slug: "vector-db", status: "coming-soon" },
        { day: 19, title: "RAG Architecture", slug: "rag-architecture", status: "coming-soon" },
        { day: 20, title: "Document Chunking Strategies", slug: "chunking", status: "coming-soon" },
        { day: 21, title: "Retrieval Optimization", slug: "retrieval-optimization", status: "coming-soon" },
        { day: 22, title: "Production RAG Pipeline", slug: "rag-pipeline", status: "coming-soon" },
      ],
    },
    {
      id: 5,
      title: "AI Agents & MongoDB",
      days: "23–26",
      color: "#ef4444",
      description: "AI Agents & Orchestration, MongoDB Advanced Patterns",
      topics: [
        { day: 23, title: "AI Agent Architectures", slug: "agent-architectures", status: "coming-soon" },
        { day: 24, title: "LangChain / LangGraph", slug: "langchain", status: "coming-soon" },
        { day: 25, title: "MongoDB Advanced Patterns", slug: "mongodb-advanced", status: "coming-soon" },
        { day: 26, title: "Agent Memory & State", slug: "agent-memory", status: "coming-soon" },
      ],
    },
    {
      id: 6,
      title: "Async Infrastructure",
      days: "27–30",
      color: "#00f5d4",
      description: "Redis & Celery, Docker & CI/CD",
      topics: [
        { day: 27, title: "Redis Patterns & Caching", slug: "redis-patterns", status: "coming-soon" },
        { day: 28, title: "Celery Task Queues", slug: "celery", status: "coming-soon" },
        { day: 29, title: "Docker for Python Apps", slug: "docker-python", status: "coming-soon" },
        { day: 30, title: "CI/CD Pipelines", slug: "cicd", status: "coming-soon" },
      ],
    },
    {
      id: 7,
      title: "Observability & System Design I",
      days: "31–34",
      color: "#f59e0b",
      description: "Observability & LLM Monitoring, System Design (Core Systems)",
      topics: [
        { day: 31, title: "Application Observability", slug: "app-observability", status: "coming-soon" },
        { day: 32, title: "LLM Monitoring & Evaluation", slug: "llm-monitoring", status: "coming-soon" },
        { day: 33, title: "System Design Core Patterns", slug: "system-design-core", status: "coming-soon" },
        { day: 34, title: "Scalability Fundamentals", slug: "scalability", status: "coming-soon" },
      ],
    },
    {
      id: 8,
      title: "API Design, Testing & Performance",
      days: "35–38",
      color: "#10b981",
      description: "API Design & Performance Testing Strategy",
      topics: [
        { day: 35, title: "RESTful API Design Principles", slug: "rest-design", status: "coming-soon" },
        { day: 36, title: "GraphQL with Python", slug: "graphql-python", status: "coming-soon" },
        { day: 37, title: "Load & Performance Testing", slug: "load-testing", status: "coming-soon" },
        { day: 38, title: "API Security Hardening", slug: "api-security", status: "coming-soon" },
      ],
    },
    {
      id: 9,
      title: "LegalTech Domain & DSA",
      days: "39–42",
      color: "#a855f7",
      description: "LegalTech Domain, Data Structures & Algorithms",
      topics: [
        { day: 39, title: "LegalTech Domain Overview", slug: "legaltech-domain", status: "coming-soon" },
        { day: 40, title: "DSA Patterns for Interviews", slug: "dsa-patterns", status: "coming-soon" },
        { day: 41, title: "Graph Algorithms", slug: "graph-algorithms", status: "coming-soon" },
        { day: 42, title: "System Design for LegalTech", slug: "legaltech-system-design", status: "coming-soon" },
      ],
    },
    {
      id: 10,
      title: "Founding Engineer Prep & Take-Home",
      days: "43–47",
      color: "#ef4444",
      description: "Founding Engineer Mindset, Take-Home Project",
      topics: [
        { day: 43, title: "Founding Engineer Mindset", slug: "founding-engineer", status: "coming-soon" },
        { day: 44, title: "Architecture Decision Records", slug: "adr", status: "coming-soon" },
        { day: 45, title: "Take-Home Project Build", slug: "take-home-project", status: "coming-soon" },
        { day: 46, title: "Code Review Best Practices", slug: "code-review", status: "coming-soon" },
        { day: 47, title: "Final Portfolio Presentation", slug: "final-presentation", status: "coming-soon" },
      ],
    },
  ],
};
